<template>
  <div class="text-center messageDiv">
    <div v-if="!isSubscribed">
      <div class="text-h5">
        You are trying to access an
        <span class="my-0 eyeDockTitle blue-grey--text text--darken-2">
          <span class="eyeText">Eye</span>
          <span class="dockText">Dock</span>
          <span class="proText mx-1">Pro</span>
        </span>
        feature.
      </div>
      <div class="subtitle-1 mt-2">Please Log in or Subscribe</div>
      <user-login
        class="my-4"
        :textButton="false"
        @loggedIn="loggedIn()"
      ></user-login>

      <router-link
        :to="{ path: 'documentation/membership-and-subscriptions' }"
        class="caption"
        >More about EyeDock Pro</router-link
      >
    </div>
    <div v-else-if="redirecting"></div>
    <div v-else>
      <div class="text-h5">
        You are logged in <br />Feel free to move about the website
      </div>
    </div>
  </div>
</template>

<script>
import UserLogin from "@/components/universalStuff/UserLogin";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "Unauthorized",
  components: { UserLogin },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return { redirecting: false };
  },
  methods: {
    loggedIn() {
      console.log("logged in");
      if (this.isSubscribed) {
        // if already logged in see if there is a "target" path in the query string
        this.redirecting = true;
        let path = this.$route?.query?.target;
        if (path) this.$router.push({ path: path });
      } else {
        // otherwise just go to the root
        this.$router.push({ path: "/" });
      }
      this.redirecting = false;
    },
  },

  computed: {},
  metaInfo() {
    return {
      title: "EyeDock | Unauthorized Page",
    };
  },
  mounted() {
    // if already logged in leave this page
    if (this.isSubscribed) this.loggedIn();
  },
};
</script>

<style scoped>
.eyeText {
  font-weight: 300 !important;
}
.dockText {
  font-weight: 600;
  text-transform: uppercase !important;
}
.proText {
  color: #c18b05;
  font-weight: 500;
}
.messageDiv {
  margin: 100px 0;
}
</style>
